<template>
  <div
    :class="{ 'pmw-hotel-nav__disabled': disabled }"
    class="pmw-hotel-nav"
    @mouseenter="showInfo = true"
    @mouseleave="showInfo = false"
  >
    <!-- TÍTULO -->
    <PmwHeading
      v-if="title"
      class="pmw-hotel-nav--title"
      size="paragraph-80"
      weight="weight-medium"
    >
      {{ title }}
    </PmwHeading>
    <!-- ITENS DO MENU -->
    <div class="pmw-hotel-nav--links">
      <!-- TOOLTIP DE ALERTA QUE O COMPONENTE ESTÁ DESATIVADO -->
      <transition name="fade">
        <Tooltip
          v-show="tooltipText && showInfo && disabled"
          :text="tooltipText"
          :minWidth="tooltipMinWidth"
          class="pmw-hotel-nav--tooltip"
        />
      </transition>
      <!-- TODO: O BOTÃO DOS "BANNERS" ESTÁ ESCONDIDO FIXAMENTE, CORRIGIR ISSO NO FUTURO -->
      <template v-for="(button, i) in links">
        <!-- ESCONDER OS ITENS SINALIZADOS E VERIFICAR SE É ROUTER-LINK OU A -->
        <component
          v-if="![...hide].includes(button.class)"
          v-bind="{
            to: button.element === 'router-link' ? button.link : false
          }"
          :key="i"
          :is="button.element"
          :href="button.element === 'a' ? button.link : false"
          class="pmw-hotel-link"
        >
          <div class="pmw-hotel-link--icon">
            <!-- ÍCONE DO BOTÃO -->
            <Icon :icon="button.icon" />
          </div>
          <div
            :class="{
              'pmw-hotel-link--title__active': active === button.class
            }"
            class="pmw-hotel-link--title"
          >
            <!-- TÍTULO DO BOTÃO -->
            <PmwParagraph size="paragraph-40">{{ button.text }}</PmwParagraph>
            <!-- ÍCONE DE REDIRECIONAMENTO - ARROW RIGHT -->
            <Icon class="pmw-hotel-link--arrow" icon="arrow-line" />
          </div>
        </component>
      </template>
    </div>
  </div>
</template>

<script>
/** =================================
 * MENU DE NAVEGAÇÃO INTERNA DO HOTEL
 * ================================== */

import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import Tooltip from '@solucoes/components-lib-tmp/src/components/elements/Tooltip'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'

export default {
  name: 'PmwHotelNav',
  components: {
    Icon,
    PmwParagraph,
    Tooltip,
    PmwHeading
  },
  props: {
    /**
     * Links do menu
     * @example [{ text: 'hotel', link: '/detalhe', icon: 'icon', element: 'a' }]
     *
     * @param {String} element tipo de elemento que deve ser renderizado pelo Vue, <a> ou <router-link>
     * @param {String} icon nome do ícone
     */
    links: {
      type: Array,
      required: true
    },
    /** Título do componente */
    title: {
      type: String,
      default: 'Menu'
    },
    /** Se o menu está desabilitado ou não */
    disabled: {
      type: Boolean,
      default: false
    },
    /** Texto da tooltip */
    tooltipText: {
      type: String,
      default: 'Selecione um hotel para ativar os atalhos.'
    },
    /** Largura mínima da tooltip */
    tooltipMinWidth: {
      type: [Number, String],
      default: 145
    },
    /** Botão ativo */
    active: {
      type: String,
      default: ''
    },
    /** Itens que devem ser escondidos no menu */
    hide: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      /** Visibilidade da tooltip */
      showInfo: false
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-hotel-nav {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  &--title {
    margin-bottom: 20px;
  }

  &--links {
    position: relative;
  }

  &--tooltip {
    bottom: calc(100% + -10px);
  }

  &__disabled {
    .pmw-hotel-nav--title,
    .pmw-hotel-link {
      opacity: 0.5;
      filter: grayscale(1);
      pointer-events: none;
    }
  }
}

.pmw-hotel-link {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  &--icon {
    width: 24px;
    height: 24px;
    border: 1px solid pmw-colors(grey-20);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-shadow: 1.5px 1.5px 5.4px rgba(0, 0, 0, 0.1);
    color: $pmw-gray-darker;

    .pmw-icon {
      width: 12px;
    }
  }

  &--title {
    flex: 1;
    display: flex;
    align-items: center;
    border-top: 1px solid pmw-colors(grey-10);
    padding: 6px 0px;

    .pmw-paragraph {
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 0px;
      color: pmw-colors(grey-90);
    }

    &__active {
      .pmw-paragraph {
        color: pmw-colors(blue-100);
        font-weight: font-weight('weight-bold');
      }
    }
  }

  &--arrow {
    color: pmw-colors(grey-90);
    width: 10px;
  }

  :last-of-type {
    &--title {
      border-bottom: 1px solid pmw-colors(grey-10);
    }
  }
}
</style>
